export default function (Alpine) {
    const accordions = new Set();

    Alpine.data('accordion', () => ({
        open: false,

        init: function () {
            const root = this.$root;
            const placeholder = root.querySelector('.placeholder');

            accordions.add(root);

            placeholder.addEventListener('click', () => {
                this.open = !this.open;
            });

            this.$watch('open', () => {
                if (this.open) {
                    accordions.forEach((el) => {
                        if (el !== root) {
                            Alpine.$data(el).open = false;
                        }
                    });

                    root.setAttribute('open', true);
                } else if (!this.open && root.hasAttribute('open')) {
                    root.removeAttribute('open');
                }
            });
        }
    }));
}

/*
--------------------------------------------------------------------------
 Usage
--------------------------------------------------------------------------

 <div x-data="accordion" class="accordion">
     <button type="button" class="placeholder">
         Başlık
     </button>

     <div class="content">
         İçerik
     </div>
 </div>

 CSS örneği:

 .accordion .content {
     display: none;
 }

 .accordion[open] .content {
     display: block;
 }

 Not:
 - Her item root elementinde x-data="accordion" olmalı.
 - Tıklanacak alanda .placeholder class'ı olmalı.
 - Açılıp kapanma root elemente gelen open attribute'u ile yönetilir.
 - Bir accordion açılınca diğer accordionlar otomatik kapanır.

*/